module.exports = __webpack_public_path__ + "static/media/guide-unwanted.71729d53.jpg";